<template>
  <v-card class="pa-3">
    <v-row no-gutters>
      <v-col cols="12" class="modal-header py-3 mb-4">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="10">
            <span class="text-center text-lg d-block font-weight-medium w-full"> داروها </span>
          </v-col>
          <v-col cols="1" class="text-left mt-n2 ml-2">
            <v-icon color="darkColor" @click="closeDialog()">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="ma-0 bodyItem" no-gutters>
      <v-col cols="12" class="item-container">
        <v-row class="ma-0">
          <span>دارو های مصرفی</span>
          <v-divider class="mt-3 mr-3"></v-divider>
        </v-row>
        <v-radio-group v-model="patientTechnicianDrugCooperationTypeValue">
          <v-row>
            <v-col cols="4" v-for="(item, index) in patientTechnicianDrugCooperationTypesList" :key="index">
              <v-radio v-bind="item"></v-radio>
            </v-col>
          </v-row>
        </v-radio-group>
        <template v-if="patientTechnicianDrugCooperationTypeValue !== 2">
          <v-row class="ma-0">
            <v-col cols="4">
              <v-autocomplete ref="drugItemAutocomplete" :items="allDrugGroupsForOther"
                no-data-text="اطلاعاتی وجود ندارد" dense outlined item-text="title" item-value="id" label="گروه دارو"
                clearable clear-icon="mdi-close-circle-outline" v-model="selectedDrugGroup" autocomplete="off"
                @change="drugGroupChange()" prepend-inner-icon="mdi-medication mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-autocomplete :items="allDrugsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                item-text="title" item-value="id" label="نام دارو" clearable return-object
                clear-icon="mdi-close-circle-outline" v-model="selectedDrug" autocomplete="off"
                prepend-inner-icon="mdi-pill-multiple mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-autocomplete :items="selectedDrug.orderTypes" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                item-text="title" item-value="id" label="نحوه تجویز" clearable clear-icon="mdi-close-circle-outline"
                v-model="patientTechnicianDrug.drugOrderTypeId" autocomplete="off"
                prepend-inner-icon="mdi-needle mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-text-field type="text" outlined id="user-moveFromStationTime" ref="moveFromStationTime" dense clearable
                autocomplete="off" @click:clear="clearDateTime('actionDate')" clear-icon="mdi-close-circle-outline"
                v-model="tempActionDate" @focus="showActionDate = true" @click="showActionDate = true" label="زمان"
                prepend-inner-icon="mdi-calendar-range mdi-18px">
                <template slot="append">
                  <v-icon @click="showActionDate = true" class="calender-background ml-n3 mt-n2" color="white">
                    mdi-calendar-range mdi-18px
                  </v-icon>
                </template>
              </v-text-field>
              <date-picker :show="showActionDate" simple v-model="patientTechnicianDrug.actionDate" type="datetime"
                @open="onOpen" @change="dateTimeChange('actionDate')" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
                display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#moveFromStationTime-moveFromStationTime"
                @close="showActionDate = false" />
            </v-col>
            <v-col cols="4">
              <v-text-field dense outlined label="دوز" clearable @keypress="isNumberWithDot($event)"
                clear-icon="mdi-close-circle-outline" type="number" @keydown.enter="pressEnterCount()"
                v-model="patientTechnicianDrug.dosage" prepend-inner-icon="mdi-needle mdi-18px"></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-row>
                <v-spacer></v-spacer>
                <v-btn rounded text class="set-btn px-9 mt-3" @click="addDrugUsage()">ثبت</v-btn>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <span>دارو های مصرفی</span>
            <v-divider class="mt-3 mr-3"></v-divider>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" class="drug-uses-part">
              <v-row>
                <v-col cols="12" v-for="item in allUsesDrugs" :key="item.id">
                  <v-card elevation="0">
                    <v-card-text>
                      <v-row>
                        <v-col class="data-part">
                          <v-row>
                            <v-col cols="3">
                              <v-row>
                                <span class="data-part-title mr-2 mt-3">{{ item.drug }}</span>
                                <span class="mr-2 mt-3">{{ item.group }}</span>
                              </v-row>
                            </v-col>
                            <v-col cols="3">
                              <v-row>
                                <span class="data-part-title mt-3">نحوه تجویز:</span>
                                <span class="mr-2 mt-3">{{ item.orderType }}</span>
                              </v-row>
                            </v-col>
                            <v-col cols="3">
                              <v-row>
                                <span class="data-part-title mt-3">دوز:</span>
                                <span class="mr-2 mt-3">{{ item.dosage }}</span>
                              </v-row>
                            </v-col>
                            <v-col cols="3">
                              <v-row>
                                <span class="data-part-title mt-3">زمان:</span>
                                <span class="mr-2 mt-3">{{ item.time }}</span>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col class="action-part">
                          <v-row>
                            <v-spacer></v-spacer>
                            <v-icon color="white" class="mt-3 mb-3"
                              @click="deletePatientTechnicianDrugFunction(item.id)">
                              mdi-delete mdi-18px
                            </v-icon>
                            <v-spacer></v-spacer>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row no-gutters class=" ma-0 height-full">
            <v-col class="text-center mt-4">موردی برای تغییر وجود ندارد</v-col>
          </v-row>
        </template>
      </v-col>
    </v-row>
    <v-row class="ma-0 mt-2">
      <v-spacer></v-spacer>
      <v-btn rounded color="darkColor" dark @click="nextDialog()">بعدی (اقلام مصرفی)</v-btn>
      <v-btn text color="darkColor" @click="closeDialog()">بستن</v-btn>
    </v-row>
  </v-card>
</template>
<script>
import FollowUpPatientStep12Helper from '@/Helpers/FollowUp/FollowUpPatientPart/FollowUpPatientStep12Helper.js';
import DrugMixin from '@/Mixins/BaseInformation/DrugMixin';
import DrugGroupMixin from '@/Mixins/BaseInformation/DrugGroupMixin';
import OrderTypeMixin from '@/Mixins/BaseInformation/OrderTypeMixin';
import ShearedMixin from '@/Mixins/Shared.js';
import SharedHelper from '@/Helpers/Shared';
import PatientTechnicianDrugMixin from '@/Mixins/FollowUp/FollowUpPatientPart/PatientTechnicianDrugMixin.js';
export default {
  mixins: [
    FollowUpPatientStep12Helper,
    DrugMixin,
    DrugGroupMixin,
    OrderTypeMixin,
    ShearedMixin,
    SharedHelper,
    PatientTechnicianDrugMixin,
  ],
  props: {
    patientId: {
      type: Number,
      require: true,
      default: null,
    },
  },
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      this.getListOfDrugGroupsForOther();
      this.getAllPatientTechnicianDrugFunction(this.patientId);
    },
    closeDialog() {
      this.$emit('reloadApiFun');
    },
    nextDialog() {
      this.$emit('goToNextDialog');
    },
    pressEnterCount() {
      this.addDrugUsage()
      this.$nextTick(() => {
        this.$refs.drugItemAutocomplete?.focus();
      });
    },
  },
};
</script>
<style scoped>
.bodyItem {
  max-height: 575px !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.item-container {
  min-height: 460px;
}

.drug-uses-part {
  height: 35vh;
  overflow-y: auto;
}

.calender-background {
  background: #79747e;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}

.set-btn {
  background: var(--background-color) !important;
  color: var(--dark-color) !important;
  letter-spacing: normal;
  border: 1px solid var(--dark-color);
}

.action-part {
  width: 3%;
  max-width: 3%;
  min-width: 3%;
  background: var(--dark-color) !important;
  border-top-left-radius: 7px !important;
  border-bottom-left-radius: 7px !important;
}

.data-part {
  width: 97%;
  max-width: 97%;
  min-width: 97%;
  background: var(--background-color) !important;
  border-top-right-radius: 7px !important;
  border-bottom-right-radius: 7px !important;
}

.data-part-title {
  font-weight: 600;
  font-size: 14px;
  color: #212121;
}
</style>
